import { render, staticRenderFns } from "./TaskFiles.vue?vue&type=template&id=9ec16b62"
import script from "./TaskFiles.vue?vue&type=script&lang=js"
export * from "./TaskFiles.vue?vue&type=script&lang=js"
import style0 from "./TaskFiles.vue?vue&type=style&index=0&id=9ec16b62&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports